"use client";
import {
  useDisclosureStore
} from "../__chunks/WYCIER3C.js";
import {
  DisclosureContextProvider
} from "../__chunks/S6EF7IVO.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/disclosure/disclosure-provider.tsx
import { jsx } from "react/jsx-runtime";
function DisclosureProvider(props = {}) {
  const store = useDisclosureStore(props);
  return /* @__PURE__ */ jsx(DisclosureContextProvider, { value: store, children: props.children });
}
export {
  DisclosureProvider
};
